import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { PatientsService } from "../../patient-service/patients.service";
import { take } from "rxjs/operators";
import { DocPopupComponent } from "src/app/doctor-section/popup-section/doc-popup/doc-popup.component";
import { DialogService } from "primeng/dynamicdialog";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-singlepatient",
  templateUrl: "./singlepatient.component.html",
  styleUrls: ["./singlepatient.component.css"],
  providers: []
})
export class SinglepatientComponent implements OnInit {
  id: string;
  token: string;
  patData;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private patientService: PatientsService,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.queryParams["patid"];
    this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
      this.token = res._token;
    });
    this.getSinglePatient();
  }
  getSinglePatient() {
    this.patientService.getSinglePatient(this.id, this.token).subscribe(res => {
      this.patData = res;
    });
  }
  onPatAppointment() {
   this.router.navigate(['../','appointments'],{
     relativeTo:this.activatedRoute,
     preserveQueryParams:true
   })
  }
}
